/* eslint-disable react-hooks/rules-of-hooks */
import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useEffect,
  useContext,
  useMemo,
  useRef,
  useState,
  useLayoutEffect,
} from 'react';
import { Form, Row, Col, Skeleton, Divider } from 'antd';
import { useSelector } from 'react-redux';
import moment, { Moment } from 'moment';
import * as _ from 'lodash';

import { ReactComponent as LocationIcon } from 'app/assets/img/icon_location_sub.svg';
import { ReactComponent as TimeIcon } from 'app/assets/img/icon_time_sub.svg';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow_down.svg';

import {
  Description,
  Discount,
  FormTicket,
  Image,
  StyledInputNumber,
  Title,
} from './styled';
import RenderIf from 'app/components/RenderIf';
import { DefaultImg } from 'app/components/StyledCarousel';
import useWindowSize from 'app/hooks/useWindowSize';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import TicketDateSelectable from 'app/components/TicketDateSelectable';
import { formatNumber, formatTimeFrame, generateUUID } from 'utils/helper';
import InputNumberContainer from 'app/components/InputNumberContainer';
import {
  QUANTITY_TAG,
  SelectPopupContainer,
  StyledSelect,
  PriceDisplayStatus,
} from 'app/pages/Catalog/FormItemTicket';
import StyledButton from 'app/components/StyledButton';
import GrandstandDiagram from 'app/pages/Cart/components/TicketItem/partials/components/GrandstandDiagram';
import { TICKET_TYPES } from 'utils/constants';
import useFetchData from 'app/hooks/useFetchData';
import { getPriceCartApi, getShowDetailApi } from 'app/services/showApi';
import { PaymentMethod } from 'app/pages/Cart/hooks/useCartNew';
import { CART_ERROR_TYPE } from '../TicketItem';
import { getTicketErrorMessage } from 'app/pages/Cart/components/TicketItem';
import useGetUsedArea2 from 'app/hooks/useGetUsedArea2';
import { I_TicketData } from '../../types';
import { generateTicketIdentify } from 'app/pages/Cart/utils';
import DialogDetailShow from 'app/pages/Catalog/components/DialogDetailShow';
import { StyledStack } from 'app/components/Stack';
import { StyledTag } from 'app/components/StyledTag';
import { OrderContext } from '../..';
import styled from 'styled-components';

interface FormValues {
  date: Moment;
  zone: number | string;
  restaurant: number | string;
  usedArea2: number | string;
}

interface ShowProperties {
  minAmount: number;
  jumpValue: number;
  originalPrice: number;
  price: number;
  minPrice: number;
  inventory: number;
  sellableQuantity: number;
  usedAreas2: { label: string; value: string | number }[];
}

interface ShowItemProps {
  showData: Record<string, any>;
  startDate: Date;
  endDate: Date;
  paymentMethod: PaymentMethod;
  setWarningMsg: Dispatch<SetStateAction<string | null>>;
  setTicketAdded: Dispatch<
    SetStateAction<Record<string, Partial<I_TicketData>>>
  >;
  ticketAdded: Record<string, Partial<I_TicketData>>;
  setCountDownId: Dispatch<SetStateAction<string>>;
  bpAllocatedDebt: number | null;
  setShowDataList?: React.Dispatch<React.SetStateAction<Record<string, any>[]>>;
  valueTicket?: any;
}

const ShowItem: React.FC<ShowItemProps> = props => {
  const {
    showData,
    startDate,
    endDate,
    paymentMethod,
    setWarningMsg,
    setTicketAdded,
    ticketAdded,
    setCountDownId,
    bpAllocatedDebt,
    setShowDataList,
    valueTicket,
  } = props;

  const translations = useSelector(selectTranslations);
  const { device } = useWindowSize();
  const isDesktop = device === 'desktop';

  const [disableMinus, setDisableMinus] = useState(true);
  const [isGettingPrice, setIsGettingPrice] = useState(false);
  const [isCanChoose, setIsCanChoose] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [detailShowData, setDetailShowData] = useState<Record<
    string,
    any
  > | null>(null);
  const editOrderRef = useRef<HTMLDivElement>(null);
  const [editOrderDOMRect, setEditOrderDOMRect] = useState<DOMRect | null>(
    null,
  );

  const infoUser = useSelector(selectInfoUser);

  const { originOrderDetailData } = useContext(OrderContext);

  const isShowTag = useMemo(() => {
    // if (!!originOrderDetailData?.businessPartnerAllocatedDebt) {
    //   return (
    //     !!originOrderDetailData?.businessPartnerAllocatedDebt?.bpLongTerm &&
    //     !!originOrderDetailData?.businessPartnerAllocatedDebt?.allowBuyShortTerm
    //   );
    // }
    return (
      !!infoUser?.businessPartner?.bpLongTerm &&
      !!infoUser?.businessPartner?.allowBuyShortTerm
    );
  }, [infoUser]);

  const getTicketPriceRef = useRef<NodeJS.Timeout | null>(null);
  const controlPrevValidAmountRef = useRef<{
    setPrevValidNumber: (value: number) => void;
  }>({ setPrevValidNumber: () => {} });
  const isTriggerSyncTicketAddedData = useRef(false);
  const [showProperties, setShowProperties] = useState<ShowProperties>({
    minAmount: showData?.minAmountB2b || 1,
    jumpValue: showData?.jumpValueB2b ?? 1,
    originalPrice: showData?.originalPrice,
    price: showData?.price,
    minPrice: showData?.minPrice,
    inventory: showData?.inventory,
    sellableQuantity:
      showData?.sellableQuantity ??
      showData?.inventory ??
      0,
    usedAreas2: [],
  });

  const [hasFetchedPrice, setHasFetchedPrice] = useState(false);
  const [disableCreateOrder, setDisableCreateOrder] = useState(false);

  const displayOriginalPriceFormat = useMemo(() => {
    const originalPrice = showProperties?.originalPrice;
    const price = showProperties?.price;
    const minPrice = showProperties?.minPrice;

    let displayStatus: string = PriceDisplayStatus.NA;

    const handleChangeStaus = (
      disableCreateOrderValue: boolean,
      displayStatusValue: string,
    ) => {
      setDisableCreateOrder(disableCreateOrderValue);
      displayStatus = displayStatusValue;
    };

    (() => {
      if (_.isNil(originalPrice) && hasFetchedPrice) {
        // Không có ngày chọn hoặc không có giá cơ bản sau khi fetch → NA
        handleChangeStaus(true, PriceDisplayStatus.NA);
        return;
      }

      if (_.isNil(price)) {
        // Không có giá bán
        if (!_.isNil(minPrice)) {
          // Có minB → Hiển thị "Giá chỉ từ"
          handleChangeStaus(true, PriceDisplayStatus.SHOW_FROM_PRICE);
        } else {
          // Không có minB → NA
          handleChangeStaus(true, PriceDisplayStatus.NA);
        }
        return;
      }

      if (price === 0) {
        // Có CB và B = 0 → Hiển thị CB + B (bình thường) nhưng không mua được
        handleChangeStaus(true, PriceDisplayStatus.SHOW_BASE_PRICE);
        return;
      }

      if (originalPrice > price) {
        // CB > B → Hiển thị CB + B → mua được
        handleChangeStaus(false, PriceDisplayStatus.SHOW_BASE_PRICE);
        return;
      }

      if (originalPrice === 0 || originalPrice <= price) {
        // CB == B hoặc CB < B hoặc CB = 0 → chỉ hiển thị B → mua được
        handleChangeStaus(false, PriceDisplayStatus.SHOW_PRICE_ONLY);
        return;
      }

      // Trường hợp còn lại → NA
      handleChangeStaus(true, PriceDisplayStatus.NA);
    })();

    switch (displayStatus) {
      case PriceDisplayStatus.NA:
        return (
          <div className="--price" style={{ position: 'relative', top: 6 }}>
            <span className="--price-na">N/Ađ</span>
          </div>
        );

      case PriceDisplayStatus.SHOW_BASE_PRICE:
        return (
          <>
            <del className="--price-old">
              {formatNumber(originalPrice || 0)}đ
            </del>
            <div className="--price" style={{ position: 'static', top: 6 }}>
              {formatNumber(price || 0)}đ
            </div>
          </>
        );

      case PriceDisplayStatus.SHOW_PRICE_ONLY:
        return (
          <div className="--price" style={{ position: 'static', top: 6 }}>
            {formatNumber(price || 0)}đ
          </div>
        );

      case PriceDisplayStatus.SHOW_FROM_PRICE:
        return (
          <>
            <span className="--price-from-text">
              {translations
                ? translations['b2c.txt.price_only_from']
                : 'Giá chỉ từ'}
            </span>
            <div className="--price" style={{ position: 'static', top: 6 }}>
              {formatNumber(minPrice || 0)}đ
            </div>
          </>
        );

      default:
        return (
          <div className="--price" style={{ position: 'relative', top: 6 }}>
            <span className="--price-na">N/Ađ</span>
          </div>
        );
    }
  }, [showProperties, translations]);

  const [form] = Form.useForm<FormValues>();
  const ticketAmount = Form.useWatch('amount', form);
  // Khi sửa order, tồn kho API đã trừ vé đang giữ. Cộng lại cả vé mua và vé
  // tặng theo productCode để số tồn của ShowItem khớp với TicketItem.
  const originAmountInOrder = useMemo(() => {
    const originalItems = [
      ...(originOrderDetailData?.items ?? []),
      ...(originOrderDetailData?.giftItems ?? []),
    ];
    const productCode =
      showData?.productCode ??
      showData?.product?.productCode ??
      originalItems.find(
        item => String(item?.show?.id) === String(showData.id),
      )?.productCode;
    if (!productCode) return 0;
    return originalItems.reduce(
      (total, item) =>
        item?.productCode === productCode
          ? total + Number(item?.amount ?? 0)
          : total,
      0,
    );
  }, [
    originOrderDetailData?.items,
    originOrderDetailData?.giftItems,
    showData.id,
    showData.product?.productCode,
    showData.productCode,
  ]);
  const availableSellableQuantity =
    Number(showProperties.sellableQuantity || 0) + originAmountInOrder;

  const parkDesc = showData?.park?.name;
  const noteDesc = showData?.note;

  const tags = showData?.tagInfoResponse ?? [];
  const promotions = showData?.promotionInfoResponse ?? [];

  const restaurantSelected = Form.useWatch('restaurant');
  const zoneSelected = Form.useWatch('zone');

  const grandstandData = useMemo(() => {
    const restaurantByIdSelected = showData?.restaurants?.find(
      i => i?.id === restaurantSelected,
    );
    const zoneByIdSelected = showData?.zones?.find(i => i?.id === zoneSelected);
    if (!_.isEmpty(showData?.restaurants)) {
      return restaurantByIdSelected ?? showData?.restaurants?.[0];
    }
    if (!_.isEmpty(showData?.zones)) {
      return zoneByIdSelected ?? showData?.zones?.[0];
    }
    return undefined;
  }, [
    restaurantSelected,
    showData?.restaurants,
    showData?.zones,
    zoneSelected,
  ]);

  const isTicketCable = useMemo(() => {
    return showData?.materialType === TICKET_TYPES.CABLE_CAR;
  }, [showData?.materialType]);

  const isComboTicket = useMemo(() => {
    return showData?.catalog?.mapVGS === 'S4';
  }, [showData?.catalog?.mapVGS]);

  const isComboDiffTicket = useMemo(() => {
    return (
      showData?.catalog?.mapVGS === 'S4' &&
      showData?.park?.workstationId === 'DIF'
    );
  }, [showData?.catalog?.mapVGS, showData?.park?.workstationId]);

  const hasRestaurants = useMemo(() => {
    return !_.isNil(showData?.restaurants) && !_.isEmpty(showData?.restaurants);
  }, [showData?.restaurants]);

  const { onFetchData: onGetUsedArea2 } = useGetUsedArea2({
    payloadData: {
      date: form.getFieldValue('date'),
      show_id: showData?.id,
      restaurant_id: form.getFieldValue('restaurant'),
      zone_id: form.getFieldValue('zone'),
      ...(bpAllocatedDebt ? { bpAllocatedDebt: bpAllocatedDebt } : {}),
    },
    applyZone: !isTicketCable,
    applyUsedZone2: !isTicketCable,
    isRestaurant: hasRestaurants,
    IIFE: false,
  });

  const { onFetchData: onGetTicketPrice } = useFetchData({
    actionApi: getPriceCartApi,
    IIFE: false,
  });

  const convertDataOption = (arr, type) => {
    let result = [];
    if (arr?.length) {
      result = arr.map(item => ({
        ...item,
        value: item.id,
        label: ['zone', 'restaurants'].includes(type)
          ? item?.name
          : item?.timeFrom,
      }));
    }
    return result;
  };

  const checkTicketIsSelected = useCallback(() => {
    const identify = generateTicketIdentify({
      showId: showData.id,
      performanceId: undefined,
      zoneId: form.getFieldValue('zone'),
      date: form.getFieldValue('date').format('YYYY-MM-DD'),
      restaurantId: form.getFieldValue('restaurant'),
      usedArea2: form.getFieldValue('usedArea2'),
    });

    const ticketDataSelected = ticketAdded[identify];

    setIsSelected(!!ticketDataSelected);

    return {
      isSelected: !!ticketDataSelected,
      ticketDataSelected,
    };
  }, [form, showData.id, ticketAdded]);

  const handleUpdateTicketAddedData = useCallback(
    (dataUpdate: Partial<I_TicketData>) => {
      const identify = generateTicketIdentify({
        showId: showData.id,
        performanceId: undefined,
        zoneId: form.getFieldValue('zone'),
        date: form.getFieldValue('date').format('YYYY-MM-DD'),
        restaurantId: form.getFieldValue('restaurant'),
        usedArea2: form.getFieldValue('usedArea2'),
      });

      setTicketAdded(prev => ({
        ...prev,
        [identify]: { ...prev[identify], ...dataUpdate },
      }));
    },
    [form, setTicketAdded, showData.id],
  );

  const handleSelectTicket = useCallback(() => {
    const identify = generateTicketIdentify({
      showId: showData.id,
      performanceId: undefined,
      zoneId: form.getFieldValue('zone'),
      date: form.getFieldValue('date').format('YYYY-MM-DD'),
      restaurantId: form.getFieldValue('restaurant'),
      usedArea2: form.getFieldValue('usedArea2'),
    });

    setTicketAdded(prev => {
      setIsSelected(true);
      const usedArea2ObjectSelected = showProperties.usedAreas2.find(
        item => item.value === form.getFieldValue('usedArea2'),
      );
      const restaurantObjectSelected = showData?.restaurants?.find(
        item => item.id === form.getFieldValue('restaurant'),
      );
      return {
        [identify]: {
          key: identify + Date.now(),
          identify,
          amount: form.getFieldValue('amount'),
          catalog: showData.catalog,
          date: {
            dateOrigin: form.getFieldValue('date').format('YYYY-MM-DD'),
          },
          materialType: showData.materialType,
          price: showProperties.price,
          originalPrice: showProperties.price,
          park: showData.park,
          usedAreas2: showProperties.usedAreas2,
          product: {
            isLongTerm: showData?.isLongTerm,
            usedArea2Object: {
              label: usedArea2ObjectSelected?.label,
              value: usedArea2ObjectSelected?.value,
            },
            originalPrice: showProperties.originalPrice,
            park: showData.park,
            id: showData?.ticketId,
          },
          show: showData,
          restaurant: {
            id: form.getFieldValue('restaurant'),
            label: restaurantObjectSelected?.label,
            name: restaurantObjectSelected?.name,
          },
          inventory: showProperties.inventory,
        },
        ...prev,
      };
    });
  }, [
    form,
    setTicketAdded,
    showData,
    showProperties.inventory,
    showProperties.originalPrice,
    showProperties.price,
    showProperties.usedAreas2,
  ]);

  const handleUnSelectTicket = useCallback(() => {
    const identify = generateTicketIdentify({
      showId: showData.id,
      performanceId: undefined,
      zoneId: form.getFieldValue('zone'),
      date: form.getFieldValue('date').format('YYYY-MM-DD'),
      restaurantId: form.getFieldValue('restaurant'),
      usedArea2: form.getFieldValue('usedArea2'),
    });

    setIsSelected(false);
    setTicketAdded(prev => {
      const { [identify]: _, ...restTickets } = prev;
      return restTickets;
    });
  }, [form, setTicketAdded, showData.id]);

  const handleGetTicketPrice = useCallback(
    (params: {
      show_id: string | number;
      date: string;
      zone_id?: string | number;
      restaurant_id?: string | number;
      used_area2?: string | number;
      amount: number | string;
    }) => {
      let isTryGetPrice = false;
      const _params = { ...params };

      const { isSelected, ticketDataSelected } = checkTicketIsSelected();

      if (isSelected && isTriggerSyncTicketAddedData.current) {
        _params.amount = (ticketDataSelected?.amount ?? 0)?.toString();
        form.setFieldValue('amount', ticketDataSelected?.amount);
        controlPrevValidAmountRef.current.setPrevValidNumber(
          ticketDataSelected?.amount!,
        );
        isTriggerSyncTicketAddedData.current = false;
      }

      const formData = new FormData();
      Object.entries(_params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(`items[0][${key}]`, value?.toString());
        }
      });
      formData.append(`items[0][payment]`, paymentMethod!.toString());
      if (bpAllocatedDebt)
        formData.append(
          `items[0][bpAllocatedDebt]`,
          bpAllocatedDebt.toString(),
        );
      setIsGettingPrice(true);
      setHasFetchedPrice(true);
      onGetTicketPrice({
        payloadData: formData,
        callback: {
          onSuccess: response => {
            const result = response[0];

            setShowDataList &&
              setShowDataList(prev => {
                return prev?.map(item => {
                  if (item?.id === +response?.[0]?.show_id) {
                    return {
                      ...item,
                      isLongTerm: !!response?.[0]?.isLongTerm,
                      ticketId: response?.[0]?.id,
                    };
                  }
                  return item;
                });
              });

            const maxAmountByJumpValue =
              Math.floor(+result?.inventory / showProperties.jumpValue) *
              showProperties.jumpValue;

            if (
              maxAmountByJumpValue &&
              form.getFieldValue('amount') > maxAmountByJumpValue
            ) {
              isTryGetPrice = true;
              form.setFieldValue('amount', maxAmountByJumpValue);
              controlPrevValidAmountRef.current.setPrevValidNumber(
                maxAmountByJumpValue,
              );
              return handleGetTicketPrice({
                date: params.date,
                zone_id: params.zone_id,
                show_id: params.show_id,
                used_area2: params.used_area2,
                restaurant_id: params.restaurant_id,
                amount: maxAmountByJumpValue?.toString(),
              });
            }

            form.setFields([{ name: 'date', errors: [] }]);

            const inventory = result?.inventory ? +result.inventory : 0;
            const sellableQuantity = Number(
              result?.sellableQuantity ?? inventory,
            );
            setShowProperties(prev => ({
              ...prev,
              originalPrice: result.originalPrice,
              price: result.price,
              inventory,
              sellableQuantity,
            }));

            const error = result?.error;
            const errorTime = result?.errorTime;
            const errorTicket = result?.errorTicket;
            if (error || errorTime || errorTicket) {
              setIsCanChoose(false);
              if (isSelected) handleUnSelectTicket();

              if (error)
                form.setFields([
                  {
                    name:
                      error?.errorType === CART_ERROR_TYPE.ERROR_TIME
                        ? 'date'
                        : 'amount',
                    errors: [
                      getTicketErrorMessage(
                        error,
                        (key, fallback) => translations?.[key] ?? fallback,
                        result,
                      ) || error?.message,
                    ],
                  },
                ]);

              if (errorTime)
                form.setFields([
                  {
                    name: 'date',
                    errors: [errorTime],
                  },
                ]);

              if (errorTicket)
                form.setFields([
                  {
                    name: 'amount',
                    errors: [errorTicket],
                  },
                ]);
            } else {
              setIsCanChoose(
                availableSellableQuantity >= showProperties.minAmount &&
                  +params.amount >= showProperties.minAmount,
              );

              if (isSelected)
                handleUpdateTicketAddedData({ amount: +params.amount });
            }
          },
          onError: error => {
            form.setFields([{ name: 'date', errors: [error?.message] }]);
            setIsCanChoose(false);
            if (isSelected) handleUnSelectTicket();
          },
          onFinally: () => {
            setIsGettingPrice(isTryGetPrice);
          },
        },
      });
    },
    [
      checkTicketIsSelected,
      form,
      handleUnSelectTicket,
      handleUpdateTicketAddedData,
      onGetTicketPrice,
      paymentMethod,
      showProperties.jumpValue,
      showProperties.minAmount,
      bpAllocatedDebt,
    ],
  );

  const getMinPrice = async (params: { date: string; show_id: number }) => {
    try {
      setIsGettingPrice(true);

      const res = await getShowDetailApi({
        id: params.show_id,
        date: moment(params.date).format('YYYY-MM-DD'),
        ticketType: sessionStorage.getItem('ticketType'),
      });

      if (res?.status === 200) {
        setShowProperties(prev => ({
          ...prev,
          minPrice: res?.data?.minPrice,
        }));
      }
    } catch (error: any) {
      form.setFields([{ name: 'date', errors: [error?.message] }]);
    } finally {
      setIsGettingPrice(false);
    }
  };

  const onCheckSyncTicketAddedData = useCallback(() => {
    const { isSelected } = checkTicketIsSelected();
    if (isSelected) isTriggerSyncTicketAddedData.current = true;
  }, [checkTicketIsSelected]);

  const handleChangeUsedArea2 = useCallback(
    usedArea2 => {
      setIsCanChoose(false);

      const date = form.getFieldValue('date');
      const zone = form.getFieldValue('zone');
      const restaurant = form.getFieldValue('restaurant');
      const amount = form.getFieldValue('amount');

      form.setFieldValue('usedArea2', usedArea2);

      handleGetTicketPrice({
        date: date?.format('YYYY-MM-DD'),
        show_id: showData.id,
        amount,
        restaurant_id: restaurant,
        zone_id: zone,
        used_area2: usedArea2,
      });
    },
    [form, handleGetTicketPrice, showData.id],
  );

  const handleGetUsedArea2 = useCallback(() => {
    const date = form.getFieldValue('date');
    const zone = form.getFieldValue('zone');
    const restaurant = form.getFieldValue('restaurant');

    onGetUsedArea2({
      payloadData: {
        date: date?.format('YYYY-MM-DD'),
        show_id: showData?.id,
        restaurant_id: restaurant,
        zone_id: zone,
        ticketType: valueTicket,
        ...(bpAllocatedDebt ? { bpAllocatedDebt: bpAllocatedDebt } : {}),
      },
      callback: {
        onSuccess: response => {
          const usedAreas2Data = response.data;

          setShowProperties(prev => ({
            ...prev,
            usedAreas2: usedAreas2Data.map(item => {
              return {
                ...item,
                label: formatTimeFrame(item.label),
              };
            }),
          }));

          if (response.data.length === 1) {
            form.setFieldValue('usedArea2', usedAreas2Data[0].value);
            onCheckSyncTicketAddedData();
            handleChangeUsedArea2(usedAreas2Data[0].value);
          } else if (_.isEmpty(form.getFieldValue('usedArea2'))) {
            getMinPrice({
              date: form.getFieldValue('date'),
              show_id: showData?.id,
            });
          }
        },
      },
    });
  }, [
    form,
    handleChangeUsedArea2,
    onGetUsedArea2,
    showData?.id,
    onCheckSyncTicketAddedData,
    bpAllocatedDebt,
  ]);

  const handleChangeDate = useCallback(
    (date: Moment | null) => {
      setIsCanChoose(false);

      form.setFields([
        { name: 'date', value: date, errors: [] },
        { name: 'amount', value: showProperties.minAmount, errors: [] },
        { name: 'zone', value: null, errors: [] },
        { name: 'restaurant', value: null, errors: [] },
        { name: 'usedArea2', value: null, errors: [] },
      ]);

      if (date === null) {
        form.setFieldValue('date', '');
        return;
      }

      if (isTicketCable) {
        onCheckSyncTicketAddedData();
        handleGetTicketPrice({
          show_id: showData?.id,
          date: date?.format('YYYY-MM-DD'),
          amount: showProperties.minAmount,
        });
        return;
      }

      const isHasOnlyOneZone = showData?.zones?.length === 1;
      if (isHasOnlyOneZone) {
        form.setFieldValue('zone', showData.zones[0].id);
        handleGetUsedArea2();
        return;
      }

      const isHasOnlyOneRestaurant = showData?.restaurants?.length === 1;
      if (isHasOnlyOneRestaurant) {
        form.setFieldValue('restaurant', showData.restaurants[0].id);
        handleGetUsedArea2();
        return;
      }

      if (_.isEmpty(showData?.zones) && _.isEmpty(showData?.restaurants)) {
        handleGetUsedArea2();
      } else if (_.isEmpty(form.getFieldValue('usedArea2'))) {
        getMinPrice({
          date: form.getFieldValue('date'),
          show_id: showData?.id,
        });
      }
    },
    [
      form,
      handleGetTicketPrice,
      handleGetUsedArea2,
      isTicketCable,
      onCheckSyncTicketAddedData,
      showData?.id,
      showData.restaurants,
      showData.zones,
      showProperties.minAmount,
    ],
  );

  const handleChangeAmount = (
    value,
    validByJumpValue?: boolean,
    event?: 'change' | 'blur',
    isRollback?: boolean,
  ) => {
    setIsCanChoose(false);
    const minAmount = showProperties.minAmount;
    const isError = value < minAmount;
    setDisableMinus(value <= minAmount);
    form.setFields([
      {
        name: 'amount',
        value: +value <= 0 ? minAmount : value,
        errors: isError
          ? [
              translations?.['b2c.catalog-detail.min-amount'].replace(
                '${number}',
                minAmount,
              ),
            ]
          : [],
      },
    ]);

    if (isError && event === 'blur') {
      controlPrevValidAmountRef.current.setPrevValidNumber(
        showProperties.minAmount,
      );

      if (isSelected) handleUnSelectTicket();
    }

    if (
      event === 'blur' &&
      (validByJumpValue || isRollback) &&
      !isError &&
      availableSellableQuantity >= minAmount
    ) {
      if (getTicketPriceRef.current) clearTimeout(getTicketPriceRef.current);

      getTicketPriceRef.current = setTimeout(() => {
        handleGetTicketPrice({
          date: form.getFieldValue('date')?.format('YYYY-MM-DD'),
          zone_id: form.getFieldValue('zone'),
          show_id: showData.id,
          used_area2: form.getFieldValue('usedArea2'),
          restaurant_id: form.getFieldValue('restaurant'),
          amount: value,
        });
      }, 500);
    }
  };

  const handleChangeZone = value => {
    setIsCanChoose(false);

    form.setFields([
      { name: 'zone', value, errors: [] },
      { name: 'usedArea2', value: null },
    ]);

    handleGetUsedArea2();
  };

  const handleChangeRestaurant = value => {
    setIsCanChoose(false);

    form.setFields([
      { name: 'restaurant', value, errors: [] },
      { name: 'usedArea2', value: null },
    ]);

    handleGetUsedArea2();
  };

  const selectRestaurantPopupContainer = useRef<HTMLDivElement>(null);
  const selectZonePopupContainer = useRef<HTMLDivElement>(null);
  const selectPerformancePopupContainer = useRef<HTMLDivElement>(null);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useLayoutEffect(() => {
    const onSetGroupTicketDetailDOMRect = () => {
      if (!editOrderRef.current) return;
      setEditOrderDOMRect(editOrderRef.current.getBoundingClientRect());
    };

    onSetGroupTicketDetailDOMRect();

    window.addEventListener('resize', onSetGroupTicketDetailDOMRect);

    return () => {
      window.removeEventListener('resize', onSetGroupTicketDetailDOMRect);
    };
  }, []);

  return (
    <>
      <Row gutter={24}>
        <Col style={{ width: isDesktop ? 'auto' : '100%' }}>
          <div
            style={{
              borderRadius: 16,
              overflow: 'hidden',
              height: 267,
              width: isDesktop ? 310 : '100%',
              position: 'relative',
            }}
          >
            <div style={{ position: 'relative', height: '100%' }}>
              <RenderIf
                condition={!!showData?.image?.original}
                fallback={<DefaultImg />}
              >
                <Image src={showData?.image?.original} alt="" />
              </RenderIf>
              <div
                style={{
                  height: 60,
                  width: '100%',
                  position: 'absolute',
                  left: 0,
                  bottom: 0,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#F8B11701',
                  backgroundImage:
                    'linear-gradient(180deg,rgba(248,177,23,0) 0%,rgba(248,177,23,0.56) 50.5%,rgba(236,86,1,0.8) 100%)',
                  cursor: 'pointer',
                  color: '#ffffff',
                }}
                onClick={() => setDetailShowData(showData)}
              >
                <span>{translations?.['b2c.txt.read-more'] ?? ''}</span>
                <i
                  className="fa-solid fa-chevron-right"
                  style={{ marginLeft: 6 }}
                ></i>
              </div>
            </div>
            <RenderIf condition={!!showData?.salePercentB2b}>
              <Discount>{`-${showData?.salePercentB2b}%`}</Discount>
            </RenderIf>
          </div>
        </Col>
        <Col style={{ width: isDesktop ? 'calc(100% - 334px)' : '100%' }}>
          <div
            style={{
              height: '100%',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Title style={{ marginTop: isDesktop ? 0 : 16 }}>
                {showData?.name}
              </Title>
              {isShowTag && (
                <div
                  style={{
                    padding: '4px 8px',
                    whiteSpace: 'nowrap',
                    background: '#F54949',
                    borderRadius: '8px',
                    color: 'white',
                    height: '25px',
                    fontSize: '12px',
                  }}
                >
                  {
                    translations?.[
                      `${
                        showData?.isLongTerm
                          ? 'b2b.txt.long-term'
                          : 'b2b.txt.short-term'
                      }`
                    ]
                  }
                </div>
              )}
            </div>

            <Row gutter={24}>
              <RenderIf condition={!!parkDesc}>
                <Col span={device !== 'mobile' && noteDesc ? 8 : 24}>
                  <Description
                    ellipsis={{
                      rows: 1,
                      tooltip: parkDesc,
                    }}
                  >
                    <LocationIcon
                      style={{
                        flexShrink: 0,
                        transform: 'translateY(-2px)',
                        marginRight: 4,
                      }}
                    />
                    {parkDesc}
                  </Description>
                </Col>
              </RenderIf>
              <RenderIf condition={!!noteDesc}>
                <Col span={device !== 'mobile' && parkDesc ? 16 : 24}>
                  <Description
                    ellipsis={{
                      rows: 1,
                      tooltip: noteDesc,
                    }}
                  >
                    <TimeIcon
                      style={{
                        flexShrink: 0,
                        transform: 'translateY(-2px)',
                        marginRight: 4,
                      }}
                    />
                    {noteDesc}
                  </Description>
                </Col>
              </RenderIf>
            </Row>
            {tags?.length ? (
              <StyledStack
                direction="row"
                style={{ flexWrap: 'wrap', marginBottom: '8px' }}
                rowGap="6px"
                columnGap="6px"
              >
                {tags?.slice(0, QUANTITY_TAG).map((itemTag, index) => (
                  <StyledTag
                    key={index}
                    title={
                      <div
                        style={{
                          gap: '5px',
                          color: itemTag?.textColor,
                        }}
                      >
                        {itemTag.content}
                      </div>
                    }
                    {...itemTag}
                    icon={itemTag?.icon?.original}
                  />
                ))}

                {tags?.length > QUANTITY_TAG && (
                  <StyledTag
                    title={tags?.slice(QUANTITY_TAG).map(item => (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'start',
                          alignItems: 'center',
                          gap: '8px',
                          color: item?.textColor,
                          marginBottom: '5px',
                        }}
                      >
                        <img
                          src={item?.icon?.original}
                          alt=""
                          height={'auto'}
                          width={14}
                        />

                        {item.content}
                      </div>
                    ))}
                    content={
                      <div style={{ fontWeight: 500 }}>
                        +{tags.length - QUANTITY_TAG}
                      </div>
                    }
                    textColor="#EC000B"
                    bgColor="#FFD6D6"
                  />
                )}
              </StyledStack>
            ) : null}

            {promotions?.length ? (
              <StyledStack
                direction="row"
                style={{ flexWrap: 'wrap', marginBottom: '8px' }}
                rowGap="10px"
                columnGap="10px"
              >
                {promotions?.slice(0, QUANTITY_TAG).map((itemTag, index) => (
                  <StyledTag
                    key={index}
                    title={
                      <div
                        style={{
                          gap: '5px',
                          color: itemTag?.textColor,
                        }}
                      >
                        {itemTag.content}
                      </div>
                    }
                    {...itemTag}
                    icon={itemTag?.icon?.original}
                  />
                ))}

                {promotions?.length > QUANTITY_TAG && (
                  <StyledTag
                    title={promotions?.slice(QUANTITY_TAG).map(item => (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'start',
                          alignItems: 'center',
                          gap: '8px',
                          color: item?.textColor,
                          marginBottom: '5px',
                        }}
                      >
                        <img
                          src={item?.icon?.original}
                          alt=""
                          height={'auto'}
                          width={14}
                        />

                        {item.content}
                      </div>
                    ))}
                    content={
                      <div style={{ fontWeight: 500 }}>
                        +{promotions.length - QUANTITY_TAG}
                      </div>
                    }
                    textColor="#EC000B"
                    bgColor="#FFD6D6"
                  />
                )}
              </StyledStack>
            ) : null}
            <FormTicket
              form={form}
              onValuesChange={() => {
                setCountDownId(generateUUID());
              }}
            >
              <Row gutter={[32, 16]}>
                <Col span={device === 'desktop' ? 12 : 24} style={{ order: 1 }}>
                  <Form.Item
                    name="date"
                    rules={[
                      {
                        required: true,
                        message: translations?.['b2c.txt.validateDate'] ?? '',
                      },
                    ]}
                    style={{ marginBottom: 0 }}
                  >
                    <TicketDateSelectable
                      isComboDiffTicket={isComboDiffTicket}
                      searchStartDate={moment(startDate)}
                      searchEndDate={moment(endDate)}
                      showDateFrom={showData.dateFrom}
                      showDateTo={showData.dateTo}
                      weekend={showData.weekend}
                      onChange={handleChangeDate}
                      onDefaultValue={handleChangeDate}
                      disabled={isGettingPrice}
                      fireworkDay={showData?.fireworkDay}
                    />
                  </Form.Item>
                </Col>

                <Col
                  span={device === 'desktop' ? 6 : 12}
                  style={{
                    order: isDesktop ? 2 : 5,
                  }}
                >
                  {isGettingPrice ? (
                    <Skeleton.Button
                      active
                      shape={'square'}
                      block
                      style={{ width: 100, opacity: 0.2 }}
                    />
                  ) : (
                    <PriceWrapper>{displayOriginalPriceFormat}</PriceWrapper>
                  )}
                </Col>

                <Col
                  span={device === 'desktop' ? 6 : 12}
                  style={{
                    order: isDesktop ? 3 : 6,
                    display: isDesktop ? 'block' : 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Form.Item
                    label=""
                    name="amount"
                    style={{ marginBottom: 0 }}
                    className="error-styled"
                  >
                    <StyledInputNumber>
                      <InputNumberContainer
                        value={ticketAmount ?? showProperties.minAmount}
                        onChange={handleChangeAmount}
                        min={1}
                        max={
                          showProperties.minAmount >
                          availableSellableQuantity
                            ? showProperties.minAmount
                            : availableSellableQuantity
                        }
                        isDisableMinus={disableMinus}
                        disabled={isGettingPrice}
                        step={showProperties.jumpValue}
                        onInvalidAmountByStep={() => {
                          setWarningMsg(
                            translations?.['b2b.txt.onlyAmount']?.replace(
                              '${jumpValue}',
                              showProperties.jumpValue,
                            ),
                          );
                        }}
                        lowerLimit={showProperties.minAmount}
                        ref={controlPrevValidAmountRef}
                        isRunChangeEventWithSameValue
                        isSyncValuePropAndCompValueWhenTextValueEmpty
                      />
                    </StyledInputNumber>
                  </Form.Item>
                </Col>

                <RenderIf
                  condition={
                    (!isTicketCable && !_.isEmpty(showData?.zones)) ||
                    (!isTicketCable && !_.isEmpty(showData?.restaurants)) ||
                    !isTicketCable
                  }
                  fallback={
                    device === 'desktop' ? (
                      <Col span={12} style={{ order: 4 }} />
                    ) : (
                      <></>
                    )
                  }
                >
                  <Col
                    span={device === 'desktop' ? 12 : 24}
                    style={{ order: isDesktop ? 4 : 2 }}
                  >
                    <Row
                      style={{ width: 'calc(100% + 16px)' }}
                      gutter={16}
                      ref={editOrderRef}
                    >
                      {!isTicketCable && !_.isEmpty(showData?.restaurants) && (
                        <Col span={12}>
                          <SelectPopupContainer
                            ref={selectRestaurantPopupContainer}
                            popupMaxWidth={
                              !!editOrderDOMRect?.width
                                ? `${editOrderDOMRect?.width}px`
                                : undefined
                            }
                            popupWidth={
                              device === 'desktop'
                                ? 'initial'
                                : !!editOrderDOMRect?.width
                                ? `${editOrderDOMRect?.width - 15}px`
                                : undefined
                            }
                          />
                          <Form.Item
                            label=""
                            name="restaurant"
                            rules={[
                              {
                                required: true,
                                message: `${
                                  translations?.['b2c.txt.plsChoose']
                                } ${
                                  showData?.usedArea1Label?.toLowerCase() ?? ''
                                }`,
                              },
                            ]}
                            style={{ marginBottom: 0 }}
                          >
                            <StyledSelect
                              options={convertDataOption(
                                showData?.restaurants,
                                'restaurants',
                              )}
                              dropdownRender={menu => (
                                <div className="custom-dropdown">{menu}</div>
                              )}
                              virtual={false}
                              placeholder={
                                showData?.usedArea1Label ||
                                translations?.['b2c.text.restaurants'] ||
                                ''
                              }
                              onChange={handleChangeRestaurant}
                              suffixIcon={<ArrowDownIcon />}
                              disabled={isGettingPrice}
                              getPopupContainer={() =>
                                selectRestaurantPopupContainer.current!
                              }
                            />
                          </Form.Item>
                        </Col>
                      )}

                      {!isTicketCable && !_.isEmpty(showData?.zones) && (
                        <Col span={12}>
                          <SelectPopupContainer
                            ref={selectZonePopupContainer}
                            popupMaxWidth={
                              !!editOrderDOMRect?.width
                                ? `${editOrderDOMRect?.width}px`
                                : undefined
                            }
                            popupWidth={
                              device === 'desktop'
                                ? 'initial'
                                : !!editOrderDOMRect?.width
                                ? `${editOrderDOMRect?.width - 15}px`
                                : undefined
                            }
                          />
                          <Form.Item
                            label=""
                            name="zone"
                            rules={[
                              {
                                required: true,
                                message: `${
                                  translations?.['b2c.txt.plsChoose']
                                } ${
                                  showData?.usedArea1Label?.toLowerCase() ?? ''
                                }`,
                              },
                            ]}
                            style={{ marginBottom: 0 }}
                          >
                            <StyledSelect
                              options={convertDataOption(
                                showData?.zones,
                                'zone',
                              )}
                              dropdownRender={menu => (
                                <div className="custom-dropdown">{menu}</div>
                              )}
                              virtual={false}
                              placeholder={
                                showData?.usedArea1Label ||
                                translations?.['b2c.text.restaurants'] ||
                                ''
                              }
                              onChange={handleChangeZone}
                              suffixIcon={<ArrowDownIcon />}
                              disabled={isGettingPrice}
                              getPopupContainer={() =>
                                selectZonePopupContainer.current!
                              }
                              placement={
                                device !== 'desktop' && showData?.restaurants
                                  ? 'bottomRight'
                                  : 'bottomLeft'
                              }
                            />
                          </Form.Item>
                        </Col>
                      )}

                      {!isTicketCable && (
                        <Col span={12}>
                          <>
                            <SelectPopupContainer
                              ref={selectPerformancePopupContainer}
                              popupMaxWidth={
                                !!editOrderDOMRect?.width
                                  ? `${editOrderDOMRect?.width}px`
                                  : undefined
                              }
                              popupWidth={
                                device === 'desktop'
                                  ? 'initial'
                                  : !!editOrderDOMRect?.width
                                  ? `${editOrderDOMRect?.width - 15}px`
                                  : undefined
                              }
                            />
                            <Form.Item
                              label=""
                              name="usedArea2"
                              rules={[
                                {
                                  required: true,
                                  message: `${
                                    translations?.['b2c.txt.plsChoose']
                                  } ${
                                    showData?.usedArea2Label?.toLowerCase() ??
                                    ''
                                  }`,
                                },
                              ]}
                              style={{ marginBottom: 0 }}
                            >
                              <StyledSelect
                                options={showProperties.usedAreas2}
                                dropdownRender={menu => (
                                  <div className="custom-dropdown">{menu}</div>
                                )}
                                virtual={false}
                                onChange={handleChangeUsedArea2}
                                placeholder={
                                  _.isEmpty(showData?.usedArea2Label)
                                    ? translations
                                      ? translations['b2c.txt.hours']
                                      : ''
                                    : showData?.usedArea2Label
                                }
                                suffixIcon={<ArrowDownIcon />}
                                disabled={
                                  isGettingPrice ||
                                  (isComboTicket &&
                                    isComboDiffTicket &&
                                    !showProperties.usedAreas2.length)
                                }
                                getPopupContainer={() =>
                                  selectPerformancePopupContainer.current!
                                }
                                placement={
                                  device !== 'desktop' &&
                                  !_.isEmpty(showData?.restaurants) &&
                                  !_.isEmpty(showData?.zones)
                                    ? 'bottomLeft'
                                    : 'bottomRight'
                                }
                              />
                            </Form.Item>
                          </>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </RenderIf>

                <Col
                  span={device === 'desktop' ? 12 : 24}
                  style={{ order: isDesktop ? 5 : 7 }}
                >
                  <StyledButton
                    textColor="#ffffff"
                    height="40px"
                    width={isDesktop ? '122px' : '100%'}
                    disabled={!isCanChoose || disableCreateOrder}
                    onClick={() =>
                      isSelected ? handleUnSelectTicket() : handleSelectTicket()
                    }
                  >
                    {translations?.[
                      isSelected ? 'b2b.btn.unchecked' : 'b2b.txt.addTicket'
                    ] ?? ''}
                  </StyledButton>
                </Col>

                <Col span={12} style={{ order: isDesktop ? 6 : 3 }}>
                  <GrandstandDiagram
                    grandstandData={grandstandData}
                    textCSS={{ marginTop: '0px' }}
                  />
                </Col>

                <Col
                  span={12}
                  style={{
                    order: isDesktop ? 7 : 4,
                    display: isDesktop ? 'block' : 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  {_.isNumber(showProperties?.sellableQuantity) && (
                    <span
                      style={{
                        color: '#808080',
                        fontWeight: 400,
                        textAlign: 'right',
                      }}
                    >
                      {'('}
                      {formatNumber(availableSellableQuantity)}{' '}
                      {translations
                        ? `${translations['b2c.txt.in-stock']}`
                        : ''}
                      {')'}
                    </span>
                  )}
                </Col>
              </Row>
            </FormTicket>
          </div>
        </Col>
      </Row>
      <Divider
        style={{
          border: 'none',
          borderBottom: 'dashed 2px #d9d9d9',
          margin: '34px 0',
        }}
      />
      <DialogDetailShow
        isShow={!!detailShowData}
        onCloseDialog={() => setDetailShowData(null)}
        detailShow={detailShowData}
      />
    </>
  );
};

export default ShowItem;

export const PriceWrapper = styled.div`
  .--price {
    color: #e92127;
    font-weight: 600;
  }
  .--price-old {
    color: #bdbdbd;
    font-weight: 500;
  }
`;
